import { IPaging } from 'common/models/IPaging';
import API from 'services/api';

export const getRenters = ({ pageNo, pageSize }: IPaging) => {
  return API.get(`/api/partners/renters?PageNo=${pageNo}&PageSize=${pageSize}`).then(
    res => res?.data,
  );
};
